<template>
    <card bg="bg-dark text-white" title="Muestras Solicitadas">
        <div class="card mt-4">
            <div class="card-body">
                <div class="row justify-content-end">
                    <div class="col-md-6">
                        <div v-if="details.length > 0" class="mt-4" style="height: 40px; width: 100%">
                            <span style="float: right">
                                <button v-if="request.requiredRevisionComponents" class="btn btn-success"
                                    @click="ValidAll">
                                    <i class="fas fa-check"></i>
                                    Validar Todas las Muestras
                                </button>
                                <button v-if="request.requiredRevisionComponents" :disabled="btnRejectDisabled"
                                    :title="btnRejectTitle" class="btn btn-danger ml-2" @click="reject">
                                    <i class="fas fa-ban"></i>
                                    Rechazar {{ buttonText }}
                                </button>
                                <button v-if="(detailNewNoWineSample.length > 0 ||
                                    detailFinishNoWineSample.length > 0) &&
                                    !request.allWineryValid
                                " class="btn btn-primary ml-2" @click="showSendOnelogyModal">
                                    <i class="fas fa-wine-bottle"></i>
                                    Enviar a Enología
                                </button>
                                <button v-if="request.requiredRevisionComponents" class="btn btn-warning ml-2"
                                    @click="showSendRevision">
                                    <i class="fas fa-undo-alt"></i>
                                    Enviar a Revisión
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <card v-if="detailNew.length > 0" title="Nuevo Producto">
            <div class="table-responsive">
                <div v-for="item in detailNew" :key="item.id">
                    <div class="card mb-4 cardShadow">
                        <span :id="'detailid-' + item.id" :data-detailid="item.id"
                            :data-validated="item.wineryValidatedAt != null ? 1 : 0" style="display: none"></span>
                        <div class="card-header">
                            <div class="row">
                                <div class="col-md-8">
                                    <h5 class="card-title d-inline"><b>VINO: {{ item.variety }}
                                            {{ item.valley }} {{ item.quality }}</b></h5>
                                </div>
                                <div class="col-md-4 text-right">
                                    <div :id="'options-butons-' + item.id">
                                        <button v-if="(item.sampleDetailStage === 3 || item.sampleDetailStage === 13 || item.sampleDetailStage === 2)
                                            && item.rejectToWinderyDispatch === null
                                            && item.rejectAt === null
                                            && item.cancelledAt === null
                                            && item.wineryValidatedAt === null" class="btn btn-warning mr-2"
                                            @click="showOneSendRevision(item)">
                                            <i class="fas fa-undo-alt"></i>
                                            Enviar a Revisión
                                        </button>
                                        <button
                                            v-if="item.sampleDetailStage === 3 || item.sampleDetailStage === 13 || (item.sampleDetailStage === 2 && !item.wineryValidatedAt)"
                                            :data-detailid="item.id" class="btn btn-success item-to-valid"
                                            @click="Valid(item.id)">
                                            <i class="fa fa-check"></i> Validar Componentes
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12 text-right">
                                    <div v-if="item.sampleDetailStage > 0" :id="'status-color-' + item.id">
                                        <h4>
                                            <b><span :class="'badge ribbon-h-' + item.statusColor"
                                                    :id="'status-text-' + item.id">
                                                    <i class="fa fa-info-circle mr-4"></i>Estado: {{ item.status }}
                                                </span></b>
                                        </h4>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th>Marca</th>
                                                <th v-if="item.comercialMixCode" style="width: 20%">
                                                    Mezcla Comercial
                                                </th>
                                                <th>Vino</th>
                                                <th>Botellas</th>
                                                <th>Etapa</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style="font-size: 20px !important;">
                                                <td>
                                                    <span class="badge badge-info p-2">{{ item.brand }}</span>
                                                </td>
                                                <td v-if="item.comercialMixCode">
                                                    <span class="badge badge-info p-2">
                                                        {{ item.comercialMix }} - {{ item.comercialMixCode }}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-info p-2">{{ item.variety }}</span>
                                                                                                        <span class="badge badge-info p-2 ml-1">{{ item.valley }}</span>
                                                    <span class="badge badge-info p-2 ml-1">{{ item.quality }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-success p-2">{{ item.quantity }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-info p-2">
                                                        <i class="fa fa-info-circle"></i>
                                                        {{ item.stage }}
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table class="table table-striped table-hover table-bordered">
                                        <tr class="thead-dark text-center">
                                            <th>Muestra Enológica</th>
                                            <th>Con Degustación</th>
                                            <th>Con Cosecha Histórica/Próxima</th>
                                            <th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
                                        </tr>
                                        <tr class="text-center" style="font-size: 20px !important;">
                                            <td>
                                                <i v-if="item.wineSample" class="fa fa-check text-success"></i>
                                                <i v-if="!item.wineSample" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.withTasting" class="fa fa-check text-success"></i>
                                                <i v-if="!item.withTasting" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.isHistoricalOrUpcoming"
                                                    class="fa fa-check text-success"></i>
                                                <i v-if="!item.isHistoricalOrUpcoming"
                                                    class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <span class="badge badge-success p-2">{{ item.finalHarvest }}</span>
                                            </td>
                                        </tr>
                                    </table>
                                    <table class="table table-striped table-hover table-bordered" v-if="item.estimatedDeliveryDateOenology
                                        || item.deliveryDateOenology
                                        || item.wineryValidatedAt
                                        || item.qualityValidationDate
                                        || item.wineryDispatch
                                        || item.internalDispatchGuide">
                                        <tr class="thead-dark">
                                            <th v-if="item.estimatedDeliveryDateOenology">Entrega Estimada Enología</th>
                                            <th v-if="item.deliveryDateOenology">Entrega Enología</th>
                                            <th v-if="item.wineryValidatedAt">Validación de Componentes</th>
                                            <th v-if="item.qualityValidationDate">Validacion de Calidad</th>
                                            <th v-if="item.wineryDispatch">Despacho desde Bodega</th>
                                            <th v-if="item.internalDispatchGuide">N° Guía Bodega</th>
                                        </tr>
                                        <tr>
                                            <td v-if="item.estimatedDeliveryDateOenology">
                                                <span class="badge badge-warning" style="font-size: 16px">{{
                                                    item.estimatedDeliveryDateOenologyString }}</span>
                                            </td>
                                            <td v-if="item.deliveryDateOenology">
                                                <span class="badge badge-success" style="font-size: 16px">{{
                                                    item.deliveryDateOenologyString }}</span>
                                            </td>
                                            <td v-if="item.wineryValidatedAt">
                                                <span class="badge badge-success" style="font-size: 16px">{{
                                                    item.wineryValidatedAtString }}</span>
                                            </td>
                                            <td v-if="item.qualityValidationDate">
                                                <span class="badge badge-success" style="font-size: 16px">
                                                    {{ item.qualityValidationDateString }}
                                                </span>
                                            </td>
                                            <td v-if="item.wineryDispatch">
                                                <span class="badge badge-primary" style="font-size: 16px">{{
                                                    item.wineryDispatchString }}</span>
                                            </td>
                                            <td v-if="item.internalDispatchGuide">
                                                <span class="badge badge-primary" style="font-size: 16px">{{
                                                    item.internalDispatchGuide }}</span>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div v-if="item.reasonRedoComponents" class="card mb-4 bg-warning">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo de revision:</b>
                                        {{ item.reasonRedoComponents }}
                                    </span>
                                </div>
                            </div>
                            <div v-if="item.status == 'Desp. Rechazado'" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo de rechazo:</b>
                                        {{ item.rejectionReason }}
                                    </span>
                                </div>
                            </div>
                            <div v-if="item.status == 'Invalidado'" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo:</b>
                                        {{ item.rejectionWineryDispatchReason }}
                                    </span>
                                </div>
                            </div>
                            <div v-if="item.cancelledAt != null" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo Cancelación:</b> {{ item.cancelledReason }}
                                    </span>
                                </div>
                            </div>
                            <a :aria-controls="'collapse' + item.id" :href="'#collapse' + item.id" aria-expanded="false"
                                class="btn btn-info btn-block" data-toggle="collapse" role="button"
                                @click="ChangeIconCollapse(item.id)">Ver más
                                <i :id="'icon' + item.id" class="fas fa-angle-down"></i>
                            </a>
                            <div :id="'collapse' + item.id" class="row collapse multi-collapse mt-2">
                                <div class="col-lg-6 col-md-12 col-sm-12">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th colspan="5">Componentes Asociados</th>
                                            </tr>
                                        </thead>
                                        <thead class="thead-light">
                                            <tr>
                                                <th style="width: 16%">Tipo</th>
                                                <th style="width: 15%">Código</th>
                                                <th>Descripción</th>
                                                <th>Stock</th>
                                                <th>Stock Actualizado</th>
                                            </tr>
                                        </thead>
                                        <thead class="thead-light">
                                            <tr>
                                                <th>Capsula</th>
                                                <td>
                                                    <span v-if="item.capsuleCode">{{ item.capsuleCode }}</span>
                                                    <span v-else="" class="badge badge-info">No Establecido</span>
                                                </td>
                                                <td>{{ item.capsuleName }}</td>
                                                <td class="text-white" :class="item.capsuleStock  > 0 ? 'bg-success' : 'bg-danger'">{{ item.capsuleStock }}</td>
                                                <td>{{ item.capsuleStockUpdateAtString }}</td>
                                            </tr>
                                            <tr>
                                                <th>Tapa</th>
                                                <td>
                                                    <span v-if="item.cappingCode">{{ item.cappingCode }}</span>
                                                    <span v-else="" class="badge badge-info">No Establecido</span>
                                                </td>
                                                <td>{{ item.cappingName }}</td>
                                                <td class="text-white" :class="item.cappingStock > 0 ? 'bg-success' : 'bg-danger'">{{ item.cappingStock }}</td>
                                                <td>{{ item.cappingStockUpdateAtString }}</td>                                         
                                            </tr>
                                            <tr>
                                                <th>Caja</th>
                                                <td>
                                                    <span v-if="item.boxCode">{{ item.boxCode }}</span>
                                                    <span v-else="" class="badge badge-info">No Establecido</span>
                                                </td>
                                                <td>{{ item.boxName }}</td>
                                                <td class="text-white" :class="item.boxStock > 0 ? 'bg-success' : 'bg-danger'">{{ item.boxStock }}</td>
                                                <td>{{ item.boxStockUpdateAtString }}</td>                                                 
                                            </tr>
                                            <tr>
                                                <th>Botella</th>
                                                <td>
                                                    <span v-if="item.bottleCode">{{ item.bottleCode }}</span>
                                                    <span v-else="" class="badge badge-info">No Establecido</span>
                                                </td>
                                                <td>{{ item.bottleName }}</td>
                                                <td class="text-white" :class="item.bottleStock > 0 ? 'bg-success' : 'bg-danger'">{{ item.bottleStock }}</td>
                                                <td>{{ item.bottleStockUpdateAtString }}</td>                                                  
                                            </tr>
                                            <tr>
                                                <th>Etiqueta</th>
                                                <td>
                                                    <span v-if="item.labelCode">{{ item.labelCode }}</span>
                                                    <span v-else="" class="badge badge-info">No Establecido</span>
                                                </td>
                                                <td>{{ item.labelName }}</td>
                                                <td class="text-white" :class="item.labelStock > 0 ? 'bg-success' : 'bg-danger'">{{ item.labelStock }}</td>
                                                <td>{{ item.labelStockUpdateAtString }}</td>                                                 
                                            </tr>
                                            <tr>
                                                <th>Contraetiqueta</th>
                                                <td>
                                                    <span v-if="item.backLabelCode">{{ item.backLabelCode }}</span>
                                                    <span v-else="" class="badge badge-info">No Establecido</span>
                                                </td>
                                                <td>{{ item.backLabelName }}</td>
                                                <td class="text-white" :class="item.backLabelStock > 0 ? 'bg-success' : 'bg-danger'">{{ item.backLabelStock }}</td>
                                                <td>{{ item.backLabelStockUpdateAtString }}</td>                                                 
                                            </tr>
                                        </thead>
                                    </table>
                                    <table class="table table-striped table-bordered">
                                        <tr class="thead-dark">
                                            <th>Otro Semielaborado</th>
                                            <th colspan="2">
                                                <table v-if="item.stockOtherSemiElaborate"
                                                    style="margin-bottom: 0px !important"
                                                    class="table table-sm table-bordered"
                                                    :class="item.stockOtherSemiElaborate.stock > 0 ? 'table-supply-stock-success' : 'table-supply-stock-danger'">
                                                    <tr>
                                                        <th class="text-left pl-2" style="width: 15% !important;">
                                                            <i class="fas fa-cubes"></i>
                                                            Stock:
                                                        </th>
                                                        <th style="width: 15% !important;" class="text-right pr-2">
                                                            <span>{{ item.stockOtherSemiElaborate.text }}</span>
                                                        </th>
                                                        <th class="text-left pl-2" style="width: 18% !important;">
                                                            <i class="fas fa-seedling"></i>
                                                            Cosecha:
                                                        </th>
                                                        <th style="width: 8% !important;" class="text-right pr-2">
                                                            <span>{{ item.stockOtherSemiElaborate.harvest }}</span>
                                                        </th>
                                                        <th :class="item.stockOtherSemiElaborate.stock > 0 ? 'border-left-success' : 'border-left-danger'"
                                                            class="text-left pl-2" style="width: 20% !important;">
                                                            <i class="fas fa-clock mr-2"></i>
                                                            Actualizado:
                                                        </th>
                                                        <th class="text-right pr-2" style="width: 15% !important;">
                                                            <span>{{ item.stockOtherSemiElaborate.updatedStockAtString
                                                                }}</span>
                                                        </th>
                                                    </tr>
                                                </table>
                                            </th>
                                        </tr>
                                        <tr v-if="item.otherSemiElaborateCode">
                                            <td style="width: 22%">
                                                {{ item.otherSemiElaborateCode }}
                                            </td>
                                            <td style="width: 73%;">
                                                {{ item.otherSemiElaborateName }}
                                            </td>
                                            <td style="width: 5%">
                                                <button
                                                    @click="showOtherSemiElaborate(item.id, item.comercialMixCode, item.sku, item.finalHarvest)"
                                                    class="btn btn-sm btn-primary">
                                                    <i class="fas fa-edit"></i>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr v-else="">
                                            <td colspan="2" style="width: 73%">
                                                <span class="badge badge-info">No Establecido</span>
                                            </td>
                                            <td style="width: 5%">
                                                <button
                                                    @click="showOtherSemiElaborate(item.id, item.comercialMixCode, item.sku, item.finalHarvest)"
                                                    class="btn btn-sm btn-primary">
                                                    <i class="fas fa-edit"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div v-if="item.isNewComposition == true" class="col-md-6">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th colspan="2">
                                                    Nueva Composición
                                                </th>
                                            </tr>
                                        </thead>
                                        <thead class="thead-light">
                                            <tr>
                                                <th>Variedad</th>
                                                <th>Porcentaje</th>
                                            </tr>
                                            <tr v-for="composition in item.compositionDetails" :key="composition.id">
                                                <td v-if="item.id ===
                                                    composition.requestCommercialSampleDetailID
                                                ">
                                                    {{ composition.variety }}
                                                </td>
                                                <td v-if="item.id ===
                                                    composition.requestCommercialSampleDetailID
                                                ">
                                                    {{ composition.percent }}%
                                                </td>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                                <div class="col-md-6">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th style="width: 25%">Obs. Preparación del Vino</th>
                                                <td>{{ item.preparationRemarks }}</td>
                                            </tr>
                                            <tr>
                                                <th>Glosa Sticker</th>
                                                <td>{{ item.stickerGloss }}</td>
                                            </tr>
                                            <tr>
                                                <th>Confección Packaging</th>
                                                <td>{{ item.confectionRemarks }}</td>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                                <div class="col-md-12">
                                    <table class="table table-stripped table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th colspan="3">Observaciones Adicionales</th>
                                            </tr>
                                            <tr v-if="item.requestDetailObservations">
                                                <th style="width: 18%">Fecha</th>
                                                <th style="width: 12%">Usuario</th>
                                                <th style="width: 70%">Observación</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="observation in item.requestDetailObservations"
                                                :key="observation.id">
                                                <td>{{ observation.createdAtString }}</td>
                                                <td>{{ observation.email }}</td>
                                                <td>{{ observation.observation }}</td>
                                            </tr>
                                            <tr>
                                                <td colspan="3">
                                                    <div class="row">
                                                        <div class="col-10">
                                                            <input class="form-control"
                                                                :id="'observation-input-' + item.id" type="text" />
                                                        </div>
                                                        <div class="col-2">
                                                            <button class="btn btn-success float-right"
                                                                @click="addObservation(item.id)">
                                                                <i class="fa fa-save"></i>
                                                                <span class="ml-2">Registrar Observación</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-md-12">
                                    <table class="table table-stripped table-hover table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th colspan="5">Documentos Adjuntos</th>
                                            </tr>
                                            <tr v-if="item.documentFiles.length > 0">
                                                <th style="width: 18%">Usuario</th>
                                                <th style="width: 12%">Fecha de Carga</th>
                                                <th style="width: 54%">Nombre del Archivo</th>
                                                <th style="width: 8%">Tipo de Archivo</th>
                                                <th style="width: 8%">Opciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="doc in item.documentFiles" :key="doc.id">
                                                <td>{{ doc.email }}</td>
                                                <td>{{ doc.createdAtString }}</td>
                                                <td>{{ doc.fileName }}</td>
                                                <td style="font-size: 20px">
                                                    <span v-if="doc.fileExtension == '.pdf'" class="text-danger"><i
                                                            aria-hidden="true" class="fas fa-file-pdf"></i></span>
                                                    <span v-if="doc.fileExtension == '.jpg' ||
                                                        doc.fileExtension == '.png'
                                                    " class="text-info"><i aria-hidden="true"
                                                            class="fas fa-image"></i></span>
                                                    <span v-if="doc.fileExtension == '.xls' ||
                                                        doc.fileExtension == '.xlsx'
                                                    " class="text-success"><i aria-hidden="true"
                                                            class="fas fa-file-excel"></i></span>
                                                    <span v-if="doc.fileExtension == '.doc' ||
                                                        doc.fileExtension == '.docx'
                                                    " class="text-primary"><i class="fas fa-file-word"></i></span>
                                                </td>
                                                <td>
                                                    <button class="btn btn-sm btn-success mr-2"
                                                        @click="downloadFile(doc.id)">
                                                        <i class="fa fa-download"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </card>
        <card v-if="detailFinish.length > 0" title="Producto Terminado">
            <div v-if="detailFinish.length > 0" class="table-responsive">
                <div v-for="item in detailFinish" :key="item.id">
                    <div class="card mb-4 cardShadow">
                        <span :id="'detailid-' + item.id" :data-detailid="item.id"
                            :data-validated="item.wineryValidatedAt != null ? 1 : 0" style="display: none"></span>
                        <div class="card-header">
                            <div class="row">
                                <div class="col-md-8">
                                    <h5 class="card-title d-inline"><b>SKU: {{ item.sku }}</b></h5>
                                </div>
                                <div class="col-md-4 text-right">
                                    <div :id="'options-butons-' + item.id">
                                        <button v-if="item.sampleDetailStage === 3 || item.sampleDetailStage === 2
                                            && item.rejectToWinderyDispatch === null
                                            && item.rejectAt === null
                                            && item.cancelledAt === null
                                            && item.wineryValidatedAt === null" class="btn btn-warning mr-2"
                                            @click="showOneFinishProductSendRevision(item)">
                                            <i class="fas fa-undo-alt"></i>
                                            Enviar a Revisión
                                        </button>

                                        <button
                                            v-if="item.sampleDetailStage === 3 || item.sampleDetailStage === 13 || (item.sampleDetailStage === 2 && !item.wineryValidatedAt)"
                                            :data-detailid="item.id" class="btn btn-success item-to-valid"
                                            @click="Valid(item.id)">
                                            <i class="fa fa-check"></i> Validar Componentes
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12 text-right">
                                    <div v-if="item.sampleDetailStage > 0" :id="'status-color-' + item.id">
                                        <h4>
                                            <b><span :class="'badge ribbon-h-' + item.statusColor"
                                                    :id="'status-text-' + item.id">
                                                    <i class="fa fa-info-circle mr-4"></i>Estado: {{ item.status }}
                                                </span></b>
                                        </h4>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th>Sku</th>
                                                <th>Marca</th>
                                                <th v-if="item.comercialMixCode">Mezcla Comercial</th>
                                                <th>Vino</th>
                                                <th>Botellas</th>
                                                <th>Etapa</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style="font-size: 20px !important;">
                                                <td>
                                                    <span class="badge badge-info p-2">{{ item.sku }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-info p-2">{{ item.brand }}</span>
                                                </td>
                                                <td v-if="item.comercialMixCode">
                                                    <span class="badge badge-info p-2">
                                                        {{ item.comercialMix }} - {{ item.comercialMixCode }}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-info p-2">{{ item.variety }}</span>
                                                                                                        <span class="badge badge-info p-2 ml-1">{{ item.valley }}</span>
                                                    <span class="badge badge-info p-2 ml-1">{{ item.quality }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-success p-2">{{ item.quantity }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-info p-2">
                                                        <i class="fa fa-info-circle"></i>
                                                        {{ item.stage }}
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table class="table table-striped table-hover table-bordered">
                                        <tr class="thead-dark text-center">
                                            <th>Sku (Para Despacho)</th>
                                            <th>Muestra Enológica</th>
                                            <th>Con Degustación</th>
                                            <th>Requiere Trasvasije</th>
                                            <th>Vino No Real</th>
                                            <th>No Maquetar</th>
                                            <th>Con Cosecha Histórica/Próxima</th>
                                            <th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
                                        </tr>
                                        <tr class="text-center" style="font-size: 20px !important;">
                                            <td>
                                                <div class="row">
                                                    <div class="col-md-8">
                                                        <span class="badge badge-success p-2">{{ item.finalSku }}</span>
                                                    </div>
                                                    <div class="col-md-3 text-right">
                                                        <button v-if="item.sampleDetailStage === 3"
                                                            @click="showOtherPt(item.id, item.comercialMixCode, item.finalSku, item.finalHarvest)"
                                                            class="btn btn-sm btn-primary">
                                                            <i class="fas fa-edit"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <i v-if="item.wineSample" class="fa fa-check text-success"></i>
                                                <i v-if="!item.wineSample" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.withTasting" class="fa fa-check text-success"></i>
                                                <i v-if="!item.withTasting" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <div class="row">
                                                    <div
                                                        :class="item.sampleDetailStage === 3 ? 'col-md-6' : 'col-md-12'">
                                                        <i v-if="item.requireTransfer"
                                                            class="fa fa-check text-success"></i>
                                                        <i v-if="!item.requireTransfer"
                                                            class="fa fa-times text-danger"></i>
                                                    </div>
                                                    <div class="col-md-6" v-if="item.sampleDetailStage === 3">
                                                        <b-form-checkbox @change="changeRequireTransfer(item.id)"
                                                            :id="'requireTransfer-' + item.id"
                                                            v-model="item.requireTransfer" name="check-button"
                                                            switch></b-form-checkbox>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <i v-if="item.notRealWine" class="fa fa-check text-success"></i>
                                                <i v-if="!item.notRealWine" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.notLayout" class="fa fa-check text-success"></i>
                                                <i v-if="!item.notLayout" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.isHistoricalOrUpcoming"
                                                    class="fa fa-check text-success"></i>
                                                <i v-if="!item.isHistoricalOrUpcoming"
                                                    class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <span class="badge badge-success p-2">{{ item.finalHarvest }}</span>
                                            </td>
                                        </tr>
                                    </table>
                                    <table class="table table-striped table-hover table-bordered" v-if="item.estimatedDeliveryDateOenology
                                        || item.deliveryDateOenology
                                        || item.wineryValidatedAt
                                        || item.qualityValidationDate
                                        || item.wineryDispatch
                                        || item.internalDispatchGuide">
                                        <tr class="thead-dark">
                                            <th v-if="item.estimatedDeliveryDateOenology">Entrega Estimada Enología</th>
                                            <th v-if="item.deliveryDateOenology">Entrega Enología</th>
                                            <th v-if="item.wineryValidatedAt">Validación de Componentes</th>
                                            <th v-if="item.qualityValidationDate">Validación de Calidad</th>
                                            <th v-if="item.wineryDispatch">Despacho desde Bodega</th>
                                            <th v-if="item.internalDispatchGuide">N° Guía Bodega</th>
                                        </tr>
                                        <tr>
                                            <td v-if="item.estimatedDeliveryDateOenology">
                                                <span class="badge badge-warning" style="font-size: 16px">{{
                                                    item.estimatedDeliveryDateOenologyString
                                                    }}</span>
                                            </td>
                                            <td v-if="item.deliveryDateOenology">
                                                <span class="badge badge-success" style="font-size: 16px">{{
                                                    item.deliveryDateOenologyString
                                                    }}</span>
                                            </td>
                                            <td v-if="item.wineryValidatedAt">
                                                <span class="badge badge-success" style="font-size: 16px">{{
                                                    item.wineryValidatedAtString }}</span>
                                            </td>
                                            <td v-if="item.qualityValidationDate">
                                                <span class="badge badge-success" style="font-size: 16px">
                                                    {{ item.qualityValidationDateString }}
                                                </span>
                                            </td>
                                            <td v-if="item.wineryDispatch">
                                                <span class="badge badge-success" style="font-size: 16px">{{
                                                    item.wineryDispatchString
                                                    }}</span>
                                            </td>
                                            <td v-if="item.internalDispatchGuide">
                                                <span class="badge badge-primary" style="font-size: 16px">{{
                                                    item.internalDispatchGuide
                                                    }}</span>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div v-if="item.reasonRedoComponents" class="card mb-4 bg-warning">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo de revision:</b>
                                        {{ item.reasonRedoComponents }}
                                    </span>
                                </div>
                            </div>
                            <div v-if="item.status == 'Desp. Rechazado' ||
                                item.status === 'Rech. Calidad'
                            " class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b v-if="item.status !== 'Rech. Calidad'">Motivo de rechazo :</b>
                                        <b v-if="item.status === 'Rech. Calidad'">Motivo de rechazo de calidad:</b>
                                        {{ item.rejectionReason }}
                                    </span>
                                </div>
                            </div>
                            <div v-if="item.status == 'Invalidado'" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo:</b>
                                        {{ item.rejectionWineryDispatchReason }}
                                    </span>
                                </div>
                            </div>
                            <div v-if="item.cancelledAt != null" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo Cancelación:</b> {{ item.cancelledReason }}
                                    </span>
                                </div>
                            </div>
                            <a :aria-controls="'collapse' + item.id" :href="'#collapse' + item.id" aria-expanded="false"
                                class="btn btn-info btn-block" data-toggle="collapse" role="button"
                                @click="ChangeIconCollapse(item.id)">Ver más
                                <i :id="'icon' + item.id" class="fas fa-angle-down"></i>
                            </a>
                            <div :id="'collapse' + item.id" class="row collapse multi-collapse mt-2">
                                <div class="col-lg-6 col-md-12 col-sm-12">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th colspan="5">
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            Componentes Asociados
                                                        </div>
                                                        <div class="col-md-6 text-right">
                                                            Zona de venta:
                                                            <span class="ml-2">{{ item.saleZone }}</span>
                                                        </div>
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <thead class="thead-light">
                                            <th style="width: 8%">Posición</th>
                                            <th style="width: 15%">Código</th>
                                            <th>Componente</th>
                                            <th>Stock</th>
                                            <th>Stock Actualizado</th>
                                        </thead>
                                        <tr v-for="lc in item.components" :key="lc.id">
                                            <td>
                                                {{ lc.componentPosition }}
                                            </td>
                                            <td v-if="lc.requestCommercialSampleDetailId === item.id">
                                                {{ lc.c_sku }}
                                            </td>
                                            <td v-if="lc.requestCommercialSampleDetailId === item.id">
                                                {{ lc.d_sku }}
                                            </td>
                                            <td class="text-white" :class="lc.stock > 0 ? 'bg-success' : 'bg-danger'">
                                                {{ lc.stock }}
                                            </td>
                                            <td>
                                                {{ lc.updatedStockAtString }}
                                            </td>
                                        </tr>
                                    </table>
                                    <table class="table table-striped table-bordered">
                                        <tr class="thead-dark">
                                            <th>Semielaborado</th>
                                            <th>
                                                <table v-if="item.stockSemiElaborate"
                                                    style="margin-bottom: 0px !important"
                                                    class="table table-sm table-bordered"
                                                    :class="item.stockSemiElaborate.stock > 0 ? 'table-supply-stock-success' : 'table-supply-stock-danger'">
                                                    <tr>
                                                        <th class="text-left pl-2" style="width: 15% !important;">
                                                            <i class="fas fa-cubes"></i>
                                                            Stock:
                                                        </th>
                                                        <th style="width: 15% !important;" class="text-right pr-2">
                                                            <span>{{ item.stockSemiElaborate.text }}</span>
                                                        </th>
                                                        <th class="text-left pl-2" style="width: 18% !important;">
                                                            <i class="fas fa-seedling"></i>
                                                            Cosecha:
                                                        </th>
                                                        <th style="width: 8% !important;" class="text-right pr-2">
                                                            <span>{{ item.stockSemiElaborate.harvest }}</span>
                                                        </th>
                                                        <th :class="item.stockSemiElaborate.stock > 0 ? 'border-left-success' : 'border-left-danger'"
                                                            class="text-left pl-2" style="width: 20% !important;">
                                                            <i class="fas fa-clock mr-2"></i>
                                                            Actualizado:
                                                        </th>
                                                        <th class="text-right pr-2" style="width: 15% !important;">
                                                            <span>{{
                                                                item.stockSemiElaborate.updatedStockAtString
                                                                }}</span>
                                                        </th>
                                                    </tr>
                                                </table>
                                            </th>
                                        </tr>
                                        <tr>
                                            <td>{{ item.semiElaborateCode }}</td>
                                            <td>{{ item.semiElaborateName }}</td>
                                        </tr>
                                    </table>
                                    <table class="table table-striped table-bordered">
                                        <tr class="thead-dark">
                                            <th>Otro Semielaborado</th>
                                            <th colspan="2">
                                                <table v-if="item.stockOtherSemiElaborate"
                                                    style="margin-bottom: 0px !important"
                                                    class="table table-sm table-bordered"
                                                    :class="item.stockOtherSemiElaborate.stock > 0 ? 'table-supply-stock-success' : 'table-supply-stock-danger'">
                                                    <tr>
                                                        <th class="text-left pl-2" style="width: 15% !important;">
                                                            <i class="fas fa-cubes"></i>
                                                            Stock:
                                                        </th>
                                                        <th style="width: 15% !important;" class="text-right pr-2">
                                                            <span>{{ item.stockOtherSemiElaborate.text }}</span>
                                                        </th>
                                                        <th class="text-left pl-2" style="width: 18% !important;">
                                                            <i class="fas fa-seedling"></i>
                                                            Cosecha:
                                                        </th>
                                                        <th style="width: 8% !important;" class="text-right pr-2">
                                                            <span>{{ item.stockOtherSemiElaborate.harvest }}</span>
                                                        </th>
                                                        <th :class="item.stockOtherSemiElaborate.stock > 0 ? 'border-left-success' : 'border-left-danger'"
                                                            class="text-left pl-2" style="width: 20% !important;">
                                                            <i class="fas fa-clock mr-2"></i>
                                                            Actualizado:
                                                        </th>
                                                        <th class="text-right pr-2" style="width: 15% !important;">
                                                            <span>{{ item.stockOtherSemiElaborate.updatedStockAtString
                                                                }}</span>
                                                        </th>
                                                    </tr>
                                                </table>
                                            </th>
                                        </tr>
                                        <tr v-if="item.otherSemiElaborateCode">
                                            <td style="width: 22%">
                                                {{ item.otherSemiElaborateCode }}
                                            </td>
                                            <td style="width: 73%;">
                                                {{ item.otherSemiElaborateName }}
                                            </td>
                                            <td style="width: 5%">
                                                <button
                                                    @click="showOtherSemiElaborate(item.id, item.comercialMixCode, item.sku, item.finalHarvest)"
                                                    class="btn btn-sm btn-primary">
                                                    <i class="fas fa-edit"></i>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr v-else="">
                                            <td colspan="2" style="width: 73%">
                                                <span class="badge badge-info">No Establecido</span>
                                            </td>
                                            <td style="width: 5%">
                                                <button
                                                    @click="showOtherSemiElaborate(item.id, item.comercialMixCode, item.sku, item.finalHarvest)"
                                                    class="btn btn-sm btn-primary">
                                                    <i class="fas fa-edit"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="col-lg-6 col-md-12 col-sm-12">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th colspan="5">
                                                    <div class="row">
                                                        <div class="col-md-10">
                                                            <span v-if="item.requestSampleDetailForDispatch">Componentes
                                                                Asignados por el Área de Despacho</span>
                                                            <span v-else>Asignar Componentes desde Área de
                                                                Despacho</span>
                                                        </div>
                                                        <div class="col-md-2 text-right">
                                                            <button v-if="(item.sampleDetailStage === 3 || item.sampleDetailStage === 13)"
                                                                @click="showDispatchComponentModal(item.id, true, item.sku, item.finalHarvest)"
                                                                class="btn btn-sm btn-primary">
                                                                <i class="fas fa-edit"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <thead class="thead-light">
                                            <tr v-if="item.requestSampleDetailForDispatch">
                                                <th colspan="5">
                                                    <div class="row">
                                                        <div class="col-md-10">
                                                            Zona de venta:
                                                            <span
                                                                v-if="item.requestSampleDetailForDispatch.saleZoneName"
                                                                class="ml-2">{{
                                                                item.requestSampleDetailForDispatch.saleZoneName
                                                                }}</span>
                                                            <span v-else="" class="ml-2">{{
                                                                item.requestSampleDetailForDispatch.saleZoneCode
                                                                }}</span>
                                                        </div>
                                                        <div class="col-md-2 text-right">
                                                            <button v-if="item.sampleDetailStage === 3"
                                                                @click="deleteDispatchComponent(item.requestSampleDetailForDispatch.id, item.sku)"
                                                                class="btn btn-sm btn-danger">
                                                                <i class="fas fa-trash"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <template v-if="item.requestSampleDetailForDispatch">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th>Posición</th>
                                                    <th style="width: 15%">Código</th>
                                                    <th>Componente</th>
                                                    <th>Stock</th>
                                                    <th>Stock Actualizado</th>
                                                </tr>
                                            </thead>
                                            <tr v-for="dc in item.requestSampleDetailForDispatch.requestSampleDetailForDispatchComponents"
                                                :key="dc.id">
                                                <td>{{ dc.componentPosition }}</td>
                                                <td>{{ dc.componentCode }}</td>
                                                <td>{{ dc.component }}</td>
                                                <td class="text-white" :class="dc.stock > 0 ? 'bg-success' : 'bg-danger'">{{ dc.stock }}</td>
                                                <td>{{ dc.updatedStockAtString }}</td>
                                            </tr>
                                        </template>
                                    </table>
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th style="width: 25%">Obs. Preparación del Vino</th>
                                                <td>{{ item.preparationRemarks }}</td>
                                            </tr>
                                            <tr>
                                                <th>Glosa Sticker</th>
                                                <td>{{ item.stickerGloss }}</td>
                                            </tr>
                                            <tr>
                                                <th>Confección Packaging</th>
                                                <td>{{ item.confectionRemarks }}</td>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                                <div class="col-md-12">
                                    <table class="table table-stripped table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th colspan="3">Observaciones Adicionales</th>
                                            </tr>
                                            <tr v-if="item.requestDetailObservations">
                                                <th style="width: 18%">Fecha</th>
                                                <th style="width: 12%">Usuario</th>
                                                <th style="width: 70%">Observación</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="observation in item.requestDetailObservations"
                                                :key="observation.id">
                                                <td>{{ observation.createdAtString }}</td>
                                                <td>{{ observation.email }}</td>
                                                <td>{{ observation.observation }}</td>
                                            </tr>
                                            <tr>
                                                <td colspan="3">
                                                    <div class="row">
                                                        <div class="col-10">
                                                            <input class="form-control"
                                                                :id="'observation-input-' + item.id" type="text" />
                                                        </div>
                                                        <div class="col-2">
                                                            <button class="btn btn-success float-right"
                                                                @click="addObservation(item.id)">
                                                                <i class="fa fa-save"></i>
                                                                <span class="ml-2">Registrar Observación</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-md-12">
                                    <table class="table table-stripped table-hover table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th colspan="5">Documentos Adjuntos</th>
                                            </tr>
                                            <tr v-if="item.documentFiles.length > 0">
                                                <th style="width: 18%">Usuario</th>
                                                <th style="width: 12%">Fecha de Carga</th>
                                                <th style="width: 54%">Nombre del Archivo</th>
                                                <th style="width: 8%">Tipo de Archivo</th>
                                                <th style="width: 8%">Opciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="doc in item.documentFiles" :key="doc.id">
                                                <td>{{ doc.email }}</td>
                                                <td>{{ doc.createdAtString }}</td>
                                                <td>{{ doc.fileName }}</td>
                                                <td style="font-size: 20px">
                                                    <span v-if="doc.fileExtension == '.pdf'" class="text-danger"><i
                                                            aria-hidden="true" class="fas fa-file-pdf"></i></span>
                                                    <span v-if="doc.fileExtension == '.jpg' ||
                                                        doc.fileExtension == '.png'
                                                    " class="text-info"><i aria-hidden="true"
                                                            class="fas fa-image"></i></span>
                                                    <span v-if="doc.fileExtension == '.xls' ||
                                                        doc.fileExtension == '.xlsx'
                                                    " class="text-success"><i aria-hidden="true"
                                                            class="fas fa-file-excel"></i></span>
                                                    <span v-if="doc.fileExtension == '.doc' ||
                                                        doc.fileExtension == '.docx'
                                                    " class="text-primary"><i class="fas fa-file-word"></i></span>
                                                </td>
                                                <td>
                                                    <button class="btn btn-sm btn-success mr-2"
                                                        @click="downloadFile(doc.id)">
                                                        <i class="fa fa-download"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <alert v-else message="Aún no se registran muestras" />
        </card>
        <card v-if="detailBottle.length > 0" title="Producto Guarda Botella">
            <div class="table-responsive">
                <div v-for="item in detailBottle" :key="item.id">
                    <div class="card mb-4 cardShadow">
                        <span :id="'detailid-' + item.id" :data-detailid="item.id"
                            :data-validated="item.wineryValidatedAt != null ? 1 : 0" style="display: none"></span>
                        <div class="card-header">
                            <div class="row">
                                <div class="col-md-8">
                                    <h5 class="card-title d-inline"><b>CÓDIGO: {{ item.sku }}</b></h5>
                                </div>
                                <div class="col-md-4 text-right">
                                    <div :id="'options-butons-' + item.id">
                                        <button v-if="item.sampleDetailStage === 3
                                            && item.rejectToWinderyDispatch === null
                                            && item.rejectAt === null
                                            && item.cancelledAt === null
                                            && item.wineryValidatedAt === null" class="btn btn-warning mr-2"
                                            @click="showOneSendRevision(item)">
                                            <i class="fas fa-undo-alt"></i>
                                            Enviar a Revisión
                                        </button>
                                        <button v-if="item.sampleDetailStage === 3" :data-detailid="item.id"
                                            class="btn btn-success item-to-valid" @click="Valid(item.id)">
                                            <i class="fa fa-check"></i> Validar Componentes
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12 text-right">
                                    <div v-if="item.sampleDetailStage > 0" :id="'status-color-' + item.id">
                                        <h4>
                                            <b><span :class="'badge ribbon-h-' + item.statusColor"
                                                    :id="'status-text-' + item.id">
                                                    <i class="fa fa-info-circle mr-4"></i>Estado: {{ item.status }}
                                                </span></b>
                                        </h4>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th>Código</th>
                                                <th>Marca</th>
                                                <th v-if="item.comercialMixCode">Mezcla Comercial</th>
                                                <th>Vino</th>
                                                <th>Botellas</th>
                                                <th>Etapa</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style="font-size: 20px !important;">
                                                <td>
                                                    <span class="badge badge-info p-2">{{ item.sku }}</span>
                                                </td>
                                                <td><span class="badge badge-info p-2">{{ item.brand }}</span>
                                                </td>
                                                <td v-if="item.comercialMixCode">
                                                    <span class="badge badge-info p-2">{{ item.comercialMix }} - {{
                                                        item.comercialMixCode }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-info p-2">{{ item.variety }}</span>
                                                                                                        <span class="badge badge-info p-2 ml-1">{{ item.valley }}</span>
                                                    <span class="badge badge-info p-2 ml-1">{{ item.quality }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-success p-2">{{ item.quantity }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-info p-2">
                                                        <i class="fa fa-info-circle"></i>
                                                        {{ item.stage }}
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table class="table table-striped table-hover table-bordered">
                                        <tr class="thead-dark text-center">
                                            <th>Con Degustación</th>
                                            <th>Requiere Trasvasije</th>
                                            <th>Con Cosecha Histórica/Próxima</th>
                                            <th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
                                        </tr>
                                        <tr class="text-center" style="font-size: 20px !important;">
                                            <td>
                                                <i v-if="item.withTasting" class="fa fa-check text-success"></i>
                                                <i v-if="!item.withTasting" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <div class="row">
                                                    <div
                                                        :class="item.sampleDetailStage === 3 ? 'col-md-6' : 'col-md-12'">
                                                        <i v-if="item.requireTransfer"
                                                            class="fa fa-check text-success"></i>
                                                        <i v-if="!item.requireTransfer"
                                                            class="fa fa-times text-danger"></i>
                                                    </div>
                                                    <div class="col-md-6" v-if="item.sampleDetailStage === 3">
                                                        <b-form-checkbox @change="changeRequireTransfer(item.id)"
                                                            :id="'requireTransfer-' + item.id"
                                                            v-model="item.requireTransfer" name="check-button"
                                                            switch></b-form-checkbox>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <i v-if="item.isHistoricalOrUpcoming"
                                                    class="fa fa-check text-success"></i>
                                                <i v-if="!item.isHistoricalOrUpcoming"
                                                    class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <span class="badge badge-success p-2">{{ item.finalHarvest }}</span>
                                            </td>
                                        </tr>
                                    </table>
                                    <table class="table table-striped table-hover table-bordered" v-if="item.wineryValidatedAt
                                        || item.qualityValidationDate
                                        || item.wineryDispatch
                                        || item.internalDispatchGuide">
                                        <tr class="thead-dark">
                                            <th v-if="item.wineryValidatedAt">Validación de Componentes</th>
                                            <th v-if="item.qualityValidationDate">Validación de Calidad</th>
                                            <th v-if="item.wineryDispatch">Despacho desde Bodega</th>
                                            <th v-if="item.internalDispatchGuide">N° Guía Bodega</th>
                                        </tr>
                                        <tr>
                                            <td v-if="item.wineryValidatedAt">
                                                <span class="badge badge-success" style="font-size: 16px">{{
                                                    item.wineryValidatedAtString }}</span>
                                            </td>
                                            <td v-if="item.qualityValidationDate">
                                                <span class="badge badge-success" style="font-size: 16px">
                                                    {{ item.qualityValidationDateString }}
                                                </span>
                                            </td>
                                            <td v-if="item.wineryDispatch">
                                                <span class="badge badge-success" style="font-size: 16px">{{
                                                    item.wineryDispatchString
                                                    }}</span>
                                            </td>
                                            <td v-if="item.internalDispatchGuide">
                                                <span class="badge badge-primary" style="font-size: 16px">{{
                                                    item.internalDispatchGuide
                                                    }}</span>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div v-if="item.reasonRedoComponents" class="card mb-4 bg-warning">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo de revision:</b>
                                        {{ item.reasonRedoComponents }}
                                    </span>
                                </div>
                            </div>
                            <div v-if="item.status === 'Desp. Rechazado' ||
                                item.rejectToQuality !== null
                            " class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo de rechazo:</b>
                                        {{ item.rejectionReason }}
                                    </span>
                                </div>
                            </div>
                            <div v-if="item.status == 'Invalidado'" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo:</b>
                                        {{ item.rejectionWineryDispatchReason }}
                                    </span>
                                </div>
                            </div>
                            <div v-if="item.cancelledAt != null" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo Cancelación:</b> {{ item.cancelledReason }}
                                    </span>
                                </div>
                            </div>
                            <a :aria-controls="'collapse' + item.id" :href="'#collapse' + item.id" aria-expanded="false"
                                class="btn btn-info btn-block" data-toggle="collapse" role="button"
                                @click="ChangeIconCollapse(item.id)">Ver más
                                <i :id="'icon' + item.id" class="fas fa-angle-down"></i>
                            </a>
                            <div :id="'collapse' + item.id" class="row collapse multi-collapse mt-2">
                                <div class="col-lg-6 col-md-12 col-sm-6">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-dark"> 
                                            <tr>
                                                <th colspan="5">Componentes Asociados</th>
                                            </tr>
                                        </thead>
                                        <thead class="thead-light">
                                            <tr>
                                                <th style="width: 20%">Tipo</th>
                                                <th style="width: 15%">Código</th>
                                                <th>Descripción</th>
                                                <th>Stock</th>
                                                <th>Stock Actualizado</th>
                                            </tr>
                                        </thead>
                                        <thead class="thead-light">
                                            <tr v-if="item.capsuleName">
                                                <th>Capsula</th>
                                                <td>{{ item.capsuleCode }}</td>
                                                <td>{{ item.capsuleName }}
                                                </td>
                                                <td class="text-white" :class="item.capsuleStock > 0 ? 'bg-success' : 'bg-danger'">{{ item.capsuleStock }}</td>
                                                <td>{{ item.capsuleStockUpdateAtString }}</td>
                                            </tr>
                                            <tr v-if="item.cappingName">
                                                <th>Tapa</th>
                                                <td>{{ item.cappingCode }}</td>
                                                <td>{{ item.cappingName }}</td>
                                                <td class="text-white" :class="item.cappingStock > 0 ? 'bg-success' : 'bg-danger'">{{ item.cappingStock }}</td>
                                                <td>{{ item.cappingStockUpdateAtString }}</td>
                                            </tr>
                                            <tr v-if="item.boxName">
                                                <th>Caja</th>
                                                <td>{{ item.boxCode }}</td>
                                                <td>{{ item.boxName }}</td>
                                                <td class="text-white" :class="item.boxStock > 0 ? 'bg-success' : 'bg-danger'">{{ item.boxStock }}</td>
                                                <td>{{ item.boxStockUpdateAtString }}</td> 
                                            </tr>
                                            <tr v-if="item.bottleName">
                                                <th>Botella</th>
                                                <td>{{ item.bottleCode }}</td>
                                                <td>{{ item.bottleName }}</td>
                                                <td class="text-white" :class="item.bottleStock > 0 ? 'bg-success' : 'bg-danger'">{{ item.bottleStock }}</td>
                                                <td>{{ item.bottleStockUpdateAtString }}</td>
                                            </tr>
                                            <tr v-if="item.labelName">
                                                <th>Etiqueta</th>
                                                <td>{{ item.labelCode }}</td>
                                                <td>{{ item.labelName }}</td>
                                                <td class="text-white" :class="item.labelStock > 0 ? 'bg-success' : 'bg-danger'">{{ item.labelStock }}</td>
                                                <td>{{ item.labelStockUpdateAtString }}</td>
                                            </tr>
                                            <tr v-if="item.backLabelName">
                                                <th>Contraetiqueta</th>
                                                <td>{{ item.backLabelCode }}</td>
                                                <td>{{ item.backLabelName }}</td>
                                                <td class="text-white" :class="item.backLabelStock > 0 ? 'bg-success' : 'bg-danger'">{{ item.backLabelStock }}</td>
                                                <td>{{ item.backLabelStockUpdateAtString }}</td>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                                <div class="col-lg-6 col-md-12 col-sm-12">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-dark">
                                            <th colspan="5">
                                                <div class="row">
                                                    <div class="col-md-8">
                                                        <span v-if="item.requestSampleDetailForDispatch">Componentes
                                                            Asignados por
                                                            el Área de Despacho</span>
                                                        <span v-else>Asignar Componentes desde Área de Despacho</span>
                                                    </div>
                                                    <div class="col-md-4 text-right">
                                                        <button v-if="(item.sampleDetailStage === 3 || item.sampleDetailStage === 13)"
                                                            @click="showDispatchComponentModal(item.id, false, item.sku, item.finalHarvest)"
                                                            class="btn btn-sm btn-primary">
                                                            <i class="fas fa-edit"></i>
                                                        </button>
                                                        <button
                                                            @click="deleteDispatchComponent(item.requestSampleDetailForDispatch.id, item.sku)"
                                                            v-if="(item.sampleDetailStage === 3 || item.sampleDetailStage === 13) && item.requestSampleDetailForDispatch"
                                                            class="btn btn-sm btn-danger ml-2">
                                                            <i class="fas fa-trash"></i>
                                                        </button>
                                                    </div>                                                    
                                                </div>
                                            </th>
                                        </thead>
                                        
                                        <template v-if="item.requestSampleDetailForDispatch">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th style="width: 12%">Tipo</th>
                                                    <th style="width: 15%">Código</th>
                                                    <th>Componente</th>
                                                    <th>Stock</th>
                                                    <th>Stock Actualizado</th>
                                                </tr>
                                                <tr v-for="dc in item.requestSampleDetailForDispatch.requestSampleDetailForDispatchComponents"
                                                    :key="dc.id">
                                                    <th style="width: 16%;"> {{ dc.family }}</th>
                                                    <td style="width: 15%"> {{ dc.componentCode }}</td>
                                                    <td>{{ dc.component }} </td>
                                                    <td class="text-white" :class="dc.stock > 0 ? 'bg-success' : 'bg-danger'">{{ dc.stock }}</td>
                                                    <td>{{ dc.updatedStockAtString }}</td>
                                                </tr>
                                            </thead>
                                        </template>
                                    </table>
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th style="width: 25%">Obs. Preparación del Vino</th>
                                                <td>{{ item.preparationRemarks }}</td>
                                            </tr>
                                            <tr>
                                                <th>Glosa Sticker</th>
                                                <td>{{ item.stickerGloss }}</td>
                                            </tr>
                                            <tr>
                                                <th>Confección Packaging</th>
                                                <td>{{ item.confectionRemarks }}</td>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                                <div class="col-md-12">
                                    <table class="table table-stripped table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th colspan="3">Observaciones Adicionales</th>
                                            </tr>
                                            <tr v-if="item.requestDetailObservations">
                                                <th style="width: 18%">Fecha</th>
                                                <th style="width: 12%">Usuario</th>
                                                <th style="width: 70%">Observación</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="observation in item.requestDetailObservations"
                                                :key="observation.id">
                                                <td>{{ observation.createdAtString }}</td>
                                                <td>{{ observation.email }}</td>
                                                <td>{{ observation.observation }}</td>
                                            </tr>
                                            <tr>
                                                <td colspan="3">
                                                    <div class="row">
                                                        <div class="col-10">
                                                            <input class="form-control"
                                                                :id="'observation-input-' + item.id" type="text" />
                                                        </div>
                                                        <div class="col-2">
                                                            <button class="btn btn-success float-right"
                                                                @click="addObservation(item.id)">
                                                                <i class="fa fa-save"></i>
                                                                <span class="ml-2">Registrar Observación</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-md-12">
                                    <table class="table table-stripped table-hover table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th colspan="5">Documentos Adjuntos</th>
                                            </tr>
                                            <tr v-if="item.documentFiles.length > 0">
                                                <th style="width: 18%">Usuario</th>
                                                <th style="width: 12%">Fecha de Carga</th>
                                                <th style="width: 54%">Nombre del Archivo</th>
                                                <th style="width: 8%">Tipo de Archivo</th>
                                                <th style="width: 8%">Opciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="doc in item.documentFiles" :key="doc.id">
                                                <td>{{ doc.email }}</td>
                                                <td>{{ doc.createdAtString }}</td>
                                                <td>{{ doc.fileName }}</td>
                                                <td style="font-size: 20px">
                                                    <span v-if="doc.fileExtension == '.pdf'" class="text-danger"><i
                                                            aria-hidden="true" class="fas fa-file-pdf"></i></span>
                                                    <span v-if="doc.fileExtension == '.jpg' ||
                                                        doc.fileExtension == '.png'
                                                    " class="text-info"><i aria-hidden="true"
                                                            class="fas fa-image"></i></span>
                                                    <span v-if="doc.fileExtension == '.xls' ||
                                                        doc.fileExtension == '.xlsx'
                                                    " class="text-success"><i aria-hidden="true"
                                                            class="fas fa-file-excel"></i></span>
                                                    <span v-if="doc.fileExtension == '.doc' ||
                                                        doc.fileExtension == '.docx'
                                                    " class="text-primary"><i class="fas fa-file-word"></i></span>
                                                </td>
                                                <td>
                                                    <button class="btn btn-sm btn-success mr-2"
                                                        @click="downloadFile(doc.id)">
                                                        <i class="fa fa-download"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </card>
        <modal id="sendToOenologyModal" :lg="true" title="Enviar a Enología">
            <send-oenology-form :detailFinish="detailFinishNoWineSample" :detailNew="detailNewNoWineSample"
                :sampleToSendOenology="sampleToSendOenology"
                @sendEnologySamples="sendEnologySamples"></send-oenology-form>
        </modal>
        <modal id="sendRevisionModal" :lg="true" title="Enviar Revisión">
            <send-revision-form :detailBottle="detailBottleComponents" :detailFinish="detailFinishComponents"
                :detailNew="detailNewComponents" :sampleToSendRevision="sampleToSendRevision"
                @sendRevisionSamples="sendRevisionSamples"></send-revision-form>
        </modal>
        <modal style="max-height: 100vh; overflow-y: auto;" v-if="detailFinishedproductToRevision != null"
            id="sendOneFinishedProductToRevisionModal" :lg="true" title="Enviar a Revisión - Producto Terminado">
            <send-one-finished-product-to-revision-form :sku="detailFinishedproductToRevision.sku"
                :detail="detailFinishedproductToRevision"
                @sendComponentRevisionSamples="sendComponentRevisionSamples"></send-one-finished-product-to-revision-form>
        </modal>
        <modal id="otherSemiElaborateModal" title="Asignar otro Semielaborado" :md="true">
            <other-semielaborate-modal :harvest="harvestToStock" :othersSemiElaborateList="othersSemiElaborateList"
                @saveOtherSemilaborate="saveOtherSemilaborate" :sampleId="id" :detailId="detailIdSelected"
                :commercialMixCode="detailIdSelectedMCCode"
                :finisehdProductCode="detailIdSelectedPTCode"></other-semielaborate-modal>
        </modal>
        <modal id="otherPtModal" title="Asignar otro Producto Terminado" :md="true">
            <other-pt-modal :finalHarvest="finalHarvestSelected" :ptList="othersPtList" @saveOtherPt="saveOtherPt"
                :sampleId="id" :detailId="detailIdSelected" :commercialMixCode="detailIdSelectedMCCode"
                :finisehdProductCode="detailIdSelectedPTCode"></other-pt-modal>
        </modal>
        <modal id="dispatchComponentModal" @modalClose="cancelAsignOtherComponents" :lg="true"
            title="Asignar Componentes para Despacho">
            <div class="row">
                <div class="col">
                    <div class="row">
                        <div class="col-md-6">
                            <table class="table table-sm table-bordered">
                                <thead class="thead-light">
                                    <tr>
                                        <th style="width: 50%;" class="thead-light">
                                            <span v-if="detailSelectedIsPt">Producto Terminado</span>
                                            <span v-else="">Semielaborado</span>
                                        </th>
                                        <td class="text-right">{{ detailSelectedSku }}</td>
                                    </tr>
                                    <tr>
                                        <th style="width: 50%;" class="thead-light">
                                            Año Cosecha
                                        </th>
                                        <td class="text-right">{{ detailSelectedFinalYear }}</td>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                        <div class="col-md-6" v-if="detailSelectedIsPt">
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <strong>Zona de Venta</strong>
                                        <v-select :options="detailSelectedSalesZone" v-model="dispatchComponentSaleZone"
                                            @input="getSaleZoneComponentsDispatch()">
                                            <span slot="no-options">No se encontraron Zonas de Venta</span>
                                        </v-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12" v-if="detailSelectedIsPt && dispatchComponentBySaleZone.length">
                            <div class="row">
                                <div class="col-12">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th colspan="6">Componentes Asociados <span
                                                        class="ml-4 text-light"><i>(Seleccionar Componentes)</i></span>
                                                </th>
                                            </tr>
                                            <tr>
                                                <th style="width: 20px;"></th>
                                                <th>Posición</th>
                                                <th>Componente</th>
                                                <th>Código Componente</th>
                                                <th>Stock</th>
                                                <th>Stock Actualizado</th>
                                            </tr>
                                        </thead>
                                        <tr v-for="lc in dispatchComponentBySaleZone" :key="lc.id">
                                            <td>
                                                <input @change="componentList(lc)" class="checkedComponent"
                                                    type="checkbox" :id="'list-component-' + lc.c_component"
                                                    :value="lc.c_component" />
                                            </td>
                                            <td>
                                                {{lc.componentPosition}}
                                            </td>
                                            <td>
                                                <label :for="'list-component-' + lc.c_component">{{
                                                    lc.componentDescription
                                                    }}</label>
                                            </td>
                                            <td>
                                                {{ lc.c_component }}
                                            </td>
                                            <td class="text-white" :class="lc.stock > 0 ? 'bg-success' : 'bg-danger'">
                                                {{ lc.stock }}
                                            </td>
                                            <td>
                                                {{ lc.updatedStockAtString }}
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div v-if="!detailSelectedIsPt" class="col-md-12">
                            <div class="row">
                                <div class="form-group col-md-6">
                                    <label for>Botella</label>
                                    <div class="d-flex align-items-center">
                                        <div style="flex: 1;">
                                            <v-select @input="showStock('supply', 'bottle', bottle.code)"
                                                :options="supplyBottles" :filterable="false" v-model="bottle"
                                                @search="onSearchBottle">
                                                <template slot="no-options">
                                                    No se encontraron registros
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.label }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.label }}
                                                    </div>
                                                </template>
                                            </v-select>
                                        </div>
                                    </div>
                                    <div class="row" v-if="bottle && stockBottle.text">
                                        <div class="col-md-12">
                                            <table class="table table-sm table-bordered"
                                                :class="stockBottle.stock > 0 ? 'table-supply-stock-success' : 'table-supply-stock-danger'">
                                                <tr>
                                                    <th class="text-left pl-2" style="width: 20% !important;">
                                                        <i class="fas fa-cubes"></i>
                                                        Stock:
                                                    </th>
                                                    <th style="width: 30% !important" class="text-right pr-2">
                                                        {{ stockBottle.text }}
                                                    </th>
                                                    <th :class="stockBottle.stock > 0 ? 'border-left-success' : 'border-left-danger'"
                                                        class="text-left pl-2" style="width: 20% !important;">
                                                        <i class="fas fa-clock mr-2"></i>
                                                        Actualizado:
                                                    </th>
                                                    <th class="text-right pr-2" style="width: 30% !important">
                                                        {{ stockBottle.updatedStockAtString }}
                                                    </th>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for>Tapa</label>
                                    <div class="d-flex align-items-center">
                                        <div style="flex: 1;">
                                            <v-select @input="showStock('supply', 'capping', capping.code)"
                                                :options="supplyCappingInputs" :filterable="false" v-model="capping"
                                                @search="onSearchCapping">
                                                <template slot="no-options">
                                                    No se encontraron registros
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.label }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.label }}
                                                    </div>
                                                </template>
                                            </v-select>
                                        </div>
                                    </div>
                                    <div class="row" v-if="capping && stockCapping.text">
                                        <div class="col-md-12">
                                            <table class="table table-sm table-bordered"
                                                :class="stockCapping.stock > 0 ? 'table-supply-stock-success' : 'table-supply-stock-danger'">
                                                <tr>
                                                    <th class="text-left pl-2" style="width: 20% !important;">
                                                        <i class="fas fa-cubes"></i>
                                                        Stock:
                                                    </th>
                                                    <th style="width: 30% !important" class="text-right pr-2">
                                                        {{ stockCapping.text }}
                                                    </th>
                                                    <th :class="stockCapping.stock > 0 ? 'border-left-success' : 'border-left-danger'"
                                                        class="text-left pl-2" style="width: 20% !important;">
                                                        <i class="fas fa-clock mr-2"></i>
                                                        Actualizado:
                                                    </th>
                                                    <th class="text-right pr-2" style="width: 30% !important">
                                                        {{ stockCapping.updatedStockAtString }}
                                                    </th>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-md-6">
                                    <label for>Caja</label>
                                    <div class="d-flex align-items-center">
                                        <div style="flex: 1;">
                                            <v-select @input="showStock('supply', 'box', box.code)"
                                                :options="supplyBoxes" :filterable="false" v-model="box"
                                                @search="onSearchBox">
                                                <template slot="no-options">
                                                    No se encontraron registros
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.label }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.label }}
                                                    </div>
                                                </template>
                                            </v-select>
                                        </div>
                                    </div>
                                    <div class="row" v-if="box && stockBox.text">
                                        <div class="col-md-12">
                                            <table class="table table-sm table-bordered"
                                                :class="stockBox.stock > 0 ? 'table-supply-stock-success' : 'table-supply-stock-danger'">
                                                <tr>
                                                    <th class="text-left pl-2" style="width: 20% !important;">
                                                        <i class="fas fa-cubes"></i>
                                                        Stock:
                                                    </th>
                                                    <th style="width: 30% !important" class="text-right pr-2">
                                                        {{ stockBox.text }}
                                                    </th>
                                                    <th :class="stockBox.stock > 0 ? 'border-left-success' : 'border-left-danger'"
                                                        class="text-left pl-2" style="width: 20% !important;">
                                                        <i class="fas fa-clock mr-2"></i>
                                                        Actualizado:
                                                    </th>
                                                    <th class="text-right pr-2" style="width: 30% !important">
                                                        {{ stockBox.updatedStockAtString }}
                                                    </th>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for>Capsula</label>
                                    <div class="d-flex align-items-center">
                                        <div style="flex: 1;">
                                            <v-select @input="showStock('supply', 'capsule', capsule.code)"
                                                :options="supplyCapsules" :filterable="false" v-model="capsule"
                                                @search="onSearchCapsule">
                                                <template slot="no-options">
                                                    No se encontraron registros
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.label }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.label }}
                                                    </div>
                                                </template>
                                            </v-select>
                                        </div>
                                    </div>
                                    <div class="row" v-if="capsule && stockCapsule.text">
                                        <div class="col-md-12">
                                            <table class="table table-sm table-bordered"
                                                :class="stockCapsule.stock > 0 ? 'table-supply-stock-success' : 'table-supply-stock-danger'">
                                                <tr>
                                                    <th class="text-left pl-2" style="width: 20% !important;">
                                                        <i class="fas fa-cubes"></i>
                                                        Stock:
                                                    </th>
                                                    <th style="width: 30% !important" class="text-right pr-2">
                                                        {{ stockCapsule.text }}
                                                    </th>
                                                    <th :class="stockCapsule.stock > 0 ? 'border-left-success' : 'border-left-danger'"
                                                        class="text-left pl-2" style="width: 20% !important;">
                                                        <i class="fas fa-clock mr-2"></i>
                                                        Actualizado:
                                                    </th>
                                                    <th class="text-right pr-2" style="width: 30% !important">
                                                        {{ stockCapsule.updatedStockAtString }}
                                                    </th>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-md-6">
                                    <label for>Etiqueta</label>
                                    <div class="d-flex align-items-center">
                                        <div style="flex: 1;">
                                            <v-select @input="showStock('supply', 'label', label.code)"
                                                :options="supplyLabels" :filterable="false" v-model="label"
                                                @search="onSearchLabel">
                                                <template slot="no-options">
                                                    No se encontraron registros
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.label }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.label }}
                                                    </div>
                                                </template>
                                            </v-select>
                                        </div>
                                    </div>
                                    <div class="row" v-if="label && stockLabel.text">
                                        <div class="col-md-12">
                                            <table class="table table-sm table-bordered"
                                                :class="stockLabel.stock > 0 ? 'table-supply-stock-success' : 'table-supply-stock-danger'">
                                                <tr>
                                                    <th class="text-left pl-2" style="width: 20% !important;">
                                                        <i class="fas fa-cubes"></i>
                                                        Stock:
                                                    </th>
                                                    <th style="width: 30% !important" class="text-right pr-2">
                                                        {{ stockLabel.text }}
                                                    </th>
                                                    <th :class="stockLabel.stock > 0 ? 'border-left-success' : 'border-left-danger'"
                                                        class="text-left pl-2" style="width: 20% !important;">
                                                        <i class="fas fa-clock mr-2"></i>
                                                        Actualizado:
                                                    </th>
                                                    <th class="text-right pr-2" style="width: 30% !important">
                                                        {{ stockLabel.updatedStockAtString }}
                                                    </th>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for>Contraetiqueta</label>
                                    <div class="d-flex align-items-center">
                                        <div style="flex: 1;">
                                            <v-select @input="showStock('supply', 'backLabel', backLabel.code)"
                                                :options="supplyBackLabels" :filterable="false" v-model="backLabel"
                                                @search="onSearchBackLabel">
                                                <template slot="no-options">
                                                    No se encontraron registros
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.label }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.label }}
                                                    </div>
                                                </template>
                                            </v-select>
                                        </div>
                                    </div>
                                    <div class="row" v-if="backLabel && stockBackLabel.text">
                                        <div class="col-md-12">
                                            <table class="table table-sm table-bordered"
                                                :class="stockBackLabel.stock > 0 ? 'table-supply-stock-success' : 'table-supply-stock-danger'">
                                                <tr>
                                                    <th class="text-left pl-2" style="width: 20% !important;">
                                                        <i class="fas fa-cubes"></i>
                                                        Stock:
                                                    </th>
                                                    <th style="width: 30% !important" class="text-right pr-2">
                                                        {{ stockBackLabel.text }}
                                                    </th>
                                                    <th :class="stockBackLabel.stock > 0 ? 'border-left-success' : 'border-left-danger'"
                                                        class="text-left pl-2" style="width: 20% !important;">
                                                        <i class="fas fa-clock mr-2"></i>
                                                        Actualizado:
                                                    </th>
                                                    <th class="text-right pr-2" style="width: 30% !important">
                                                        {{ stockBackLabel.updatedStockAtString }}
                                                    </th>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="col-md-12 mt-4">
                            <button class="btn btn-success btn-block" @click="saveDispatchComponent">
                                <i class="fas fa-save"></i>
                                Guardar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
    </card>
</template>
<script>
//import toastr from "toastr";
import { Get, Post, Put, Delete } from "../../../helper/axios";
import $ from "jquery";
import _ from "lodash";
//url: /solicitudes/despacho/bodega/
export default {
    props: [
        "details",
        "id",
        "component",
        "progressDispatch",
        "minDate",
        "request",
    ],
    data() {
        return {
            Put,
            Get,
            Post,
            Delete,
            apiUrl: this.$store.getters.apiUrl,
            detailId: 0,
            listSelectSample: [],
            exist: false,
            updateDispatch: {},
            rejectionReason: "",
            shippingDate: "",
            couriers: [],
            courier: "",
            btnDisabled: true,
            validDispatch: false,
            minDateArrived: "",
            internalDispatchGuide: "",
            sampleToSendOenology: [],
            sampleToSendRevision: [],
            detailFinishedproductToRevision: {},
            detailIdSelected: 0,
            detailIdSelectedMCCode: '',
            detailIdSelectedPTCode: '',
            othersSemiElaborateList: [],
            othersPtList: [],
            detailSelectedFinalYear: null,
            detailSelectedIsPt: false,
            detailSelectedSku: null,
            dispatchComponentSaleZone: {},
            detailSelectedSalesZone: [],
            dispatchComponentFormula: [],
            dispatchComponentBySaleZone: [],
            existComponent: false,
            dispatchComponentSelected: [],
            supplyBottles: [],
            supplyCappingInputs: [],
            supplyBoxes: [],
            supplyCapsules: [],
            supplyLabels: [],
            supplyBackLabels: [],
            capsule: {},
            bottle: {},
            capping: {},
            box: {},
            label: {},
            backLabel: {},
            stock: {},
            harvestToStock: '',
            stockCapping: {},
            stockCapsule: {},
            stockBottle: {},
            stockBox: {},
            stockLabel: {},
            stockBackLabel: {},
            finalHarvestSelected: 0
        };
    },
    created() {
        this.minDateArrived = this.minDate;
        this.getCourier();
        this.getSupplies();
    },
    methods: {
        dispatch() {
            this.$swal({
                title: "¿Desea Despachar Desde Bodega " + this.buttonText + "?",
                html:
                    "</br><h5>Datos a registrar</h5><table class='text-left'><tr><th>Fecha de envío: </th><td> " +
                    this.shippingDate +
                    "</td></tr><tr><th>N° Guía de Despacho:</th><td>" +
                    this.internalDispatchGuide +
                    "</td></tr></table></br>",
                icon: "info",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
            }).then((result) => {
                if (result.value) {
                    this.updateDispatch = {
                        action: "Dispatch",
                        list: this.listSelectSample,
                        date: this.shippingDate,
                        internalDispatchGuide: this.internalDispatchGuide,
                    };

                    if (this.listSelectSample.length == 0) {
                        this.details.forEach((element) => {
                            if (
                                element.rejectAt == null &&
                                element.dispatchedAt == null &&
                                element.cancelledAt == null &&
                                element.rejectToWinderyDispatch == null
                            ) {
                                this.listSelectSample.push(element.id);
                            }
                        });
                    }
                    this.$store.commit("setLoading", true);
                    this.Put(
                        `${this.apiUrl}v1/details/winerydispatch/` + this.id,
                        this.updateDispatch,
                        () => {
                            this.$store.commit("setLoading", false);
                            this.listSelectSample = [];

                            window.toastr.success(
                                "Se ha realizado el despacho correctamente."
                            );
                            //this.$router.push("/");
                            location.reload();
                        }
                    );
                }
            });
        },
        validButton() {
            if (this.shippingDate != "") this.minDateArrived = this.shippingDate;
            else this.minDateArrived = this.minDate;

            if (this.isValid && this.shippingDate != "" && this.internalDispatchGuide)
                this.btnDisabled = false;
            else this.btnDisabled = true;
        },
        getCourier() {
            this.$store.commit("setLoading", true);
            this.Get(`${this.apiUrl}v1/courier/`, (res) => {
                this.couriers = [];
                res.data.data.forEach((item) => {
                    this.couriers.push({
                        code: item.id,
                        label: item.name,
                    });
                });
                this.$store.commit("setLoading", false);
            });
        },
        reject() {
            this.$swal({
                title: "¿Desea Rechazar " + this.buttonText + "?",
                input: "text",
                text: "Si es así, debe ingresar el motivo del rechazo",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
            }).then((result) => {
                if (result.value) {
                    if (this.listSelectSample.length == 0) {
                        this.details.forEach((element) => {
                            if (
                                element.rejectAt == null &&
                                element.dispatchedAt == null &&
                                element.wineryValidatedAt == null
                            ) {
                                this.listSelectSample.push(element.id);
                            }
                        });
                    }
                    this.updateDispatch = {
                        action: "Reject",
                        reason: result.value,
                        list: this.listSelectSample,
                    };
                    this.$store.commit("setLoading", true);
                    this.Put(
                        this.apiUrl + "v1/details/winerydispatch/" + this.id,
                        this.updateDispatch,
                        () => {
                            this.$store.commit("setLoading", false);
                            //this.$router.push("/");
                            this.listSelectSample = [];
                            this.$swal.fire(
                                "Rechazado!",
                                "La(s) solicitud(es) ha(n) sido rechazada(s) correctamente."
                            );
                            location.reload();
                        }
                    );
                }
            });
            this.updateDispatch = {};
        },
        SampleList(id) {
            for (var i = 0; i < this.listSelectSample.length; i++) {
                if (this.listSelectSample[i] === id) {
                    this.listSelectSample.splice(i, 1);
                    this.exist = true;
                }
            }

            if (this.exist == false) {
                this.listSelectSample.push(id);
            }
            this.exist = false;
        },
        getRequest() {
            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl + "v1/requestsamples/", (res) => {
                this.requests = res.data;
                this.$store.commit("setLoading", false);
            });
        },
        showSendOnelogyModal() {
            $("#sendToOenologyModal").modal("show");
        },
        showSendRevision() {
            $("#sendRevisionModal").modal("show");
        },
        showOtherSemiElaborate(detailId, commercialMixCode, finishedProductCode, harvestToStock) {
            this.othersSemiElaborateList = []
            this.detailIdSelected = detailId;
            this.detailIdSelectedMCCode = commercialMixCode;
            this.detailIdSelectedPTCode = finishedProductCode
            this.getSemiElaborateList(commercialMixCode);
            this.harvestToStock = harvestToStock
            $("#otherSemiElaborateModal").modal("show");
        },
        getSemiElaborateList(commercialMixCode) {
            if (commercialMixCode) {
                this.$store.commit("setLoading", true);
                this.semiElaboareList = [];
                let isPt = false;
                let data = "Size=20&IsPt=" + isPt + "&CommercialMixCode=" + commercialMixCode + "&NoPaged=true";
                this.Get(this.apiUrl + "v1/MasterItems/GetToSelect?" + data, (res) => {
                    res.data.forEach((element) => {
                        this.othersSemiElaborateList.push({
                            label: element.c_sku + "  " + element.d_sku,
                            code: element.c_sku,
                            brand: element.d_family,
                            quality: element.d_sub_heading,
                        });
                    });
                    this.$store.commit("setLoading", false);
                });
            }
        },
        showOtherPt(detailId, commercialMixCode, finishedProductCode, finalHarvest) {
            this.othersPtList = []
            this.detailIdSelected = detailId;
            this.detailIdSelectedMCCode = commercialMixCode;
            this.detailIdSelectedPTCode = finishedProductCode
            this.finalHarvestSelected = finalHarvest
            this.getOtherPtList(commercialMixCode);
            $("#otherPtModal").modal("show");
        },
        getOtherPtList(commercialMixCode) {
            if (commercialMixCode) {
                this.$store.commit("setLoading", true);
                this.othersPtList = [];
                let isPt = true;
                let data = "Size=20&IsPt=" + isPt + "&CommercialMixCode=" + commercialMixCode + "&IsToOtherPt=true&NoPaged=true";
                this.Get(this.apiUrl + "v1/MasterItems/GetToSelect?" + data, (res) => {
                    res.data.forEach((element) => {
                        this.othersPtList.push({
                            label: element.c_sku + "  " + element.d_sku,
                            code: element.c_sku,
                            brand: element.d_family,
                            quality: element.d_sub_heading,
                        });
                    });
                    this.$store.commit("setLoading", false);
                });
            }
        },
        showDispatchComponentModal(detailId, isPt, sku, year) {
            this.detailIdSelected = detailId;
            this.detailSelectedFinalYear = year;
            this.detailSelectedIsPt = isPt;
            this.detailSelectedSku = sku;
            if (isPt) {
                this.getSalesZoneToComponentDispatch();
            }
            $("#dispatchComponentModal").modal("show");
        },
        getSalesZoneToComponentDispatch() {
            //Harvest removed
            if (this.detailSelectedIsPt && this.detailSelectedSku) {
                this.Get(this.apiUrl + `v1/formulas/getSaleZones?sku=${this.detailSelectedSku}`, (res) => {
                    res.data.forEach((element) => {
                        this.detailSelectedSalesZone.push({
                            code: element.code,
                            label: element.saleZone
                        });
                    });
                    this.$store.commit("setLoading", false);
                    $("#dispatchComponentModal").modal("show");
                });
            }
        },
        getSaleZoneComponentsDispatch() {
            this.clearFromChangeSaleZoneOrHarvest();
            this.$store.commit("setLoading", true)
            if (this.dispatchComponentSaleZone && this.detailSelectedFinalYear && this.detailSelectedSku) {
                let saleZoneAtr = '';
                if (this.dispatchComponentSaleZone.code)
                    saleZoneAtr = `&saleZone=${this.dispatchComponentSaleZone.code}`
                this.Get(this.apiUrl + `v1/formulas/getFormulasBySkuAndHarvest?sku=${this.detailSelectedSku}${saleZoneAtr}`, (res) => {
                    this.dispatchComponentFormula = res.data.formulas;
                    this.dispatchComponentFormula.forEach((element) => {
                        this.dispatchComponentBySaleZone.push(element);
                    });
                    this.$store.commit("setLoading", false);
                });
            }
            this.$store.commit("setLoading", false);
        },
        clearFromChangeSaleZoneOrHarvest() {
            this.dispatchComponentFormula = [];
            this.dispatchComponentBySaleZone = [];
        },
        componentList(lc) {
            if (this.existComponent == false) {
                this.dispatchComponentSelected.push({
                    "d_component": lc.d_component,
                    "c_component": lc.c_component,
                    "saleZone": lc.saleZone,
                    "componentPosition": lc.componentPosition
                });
            }
            this.existComponent = false;
        },
        saveDispatchComponent() {
            let components = [];
            let data = {};
            if (this.detailSelectedIsPt) {
                this.$store.commit("setLoading", true);
                for (let i = 0; i < this.dispatchComponentSelected.length; i++) {
                    components.push({
                        component: this.dispatchComponentSelected[i].d_component,
                        componentCode: this.dispatchComponentSelected[i].c_component,
                        componentPosition: this.dispatchComponentSelected[i].componentPosition,
                    });
                }
                data = {
                    saleZoneCode: `${this.dispatchComponentSaleZone.code}`,
                    saleZoneName: this.dispatchComponentSaleZone.label,
                    sku: this.detailSelectedSku,
                    sampleType: 0,
                    detailId: this.detailIdSelected,
                    components: components
                }

            }
            else {
                if (this.box.code) {
                    components.push({
                        component: this.box.label,
                        componentCode: this.box.code,
                        family: 'CAJA'
                    })
                }
                if (this.capping.code) {
                    components.push({
                        component: this.capping.label,
                        componentCode: this.capping.code,
                        family: 'TAPA'
                    })
                }
                if (this.capsule.code) {
                    components.push({
                        component: this.capsule.label,
                        componentCode: this.capsule.code,
                        family: 'CAPSULA'
                    })
                }
                if (this.bottle.code) {
                    components.push({
                        component: this.bottle.label,
                        componentCode: this.bottle.code,
                        family: 'BOTELLA'
                    })
                }
                if (this.label.code) {
                    components.push({
                        component: this.label.label,
                        componentCode: this.label.code,
                        family: 'ETIQUETA'
                    })
                }
                if (this.backLabel.code) {
                    components.push({
                        component: this.backLabel.label,
                        componentCode: this.backLabel.code,
                        family: 'CONTRAETIQUETA'
                    })
                }
                data = {
                    sku: this.detailSelectedSku,
                    sampleType: 1,
                    detailId: this.detailIdSelected,
                    components: components
                }
            }
            this.Post(`${this.apiUrl}v1/requestsample/${this.id}/details/saveDispatchComponent`, data, () => {
                this.$store.commit("setLoading", false);
                window.toastr.success('Se ha Registrado los Componentes para Despacho');
                this.$emit("saveDispatchComponent");
            });
            this.detailIdSelected = 0;
            this.detailSelectedFinalYear = null;
            this.detailSelectedIsPt = false;
            this.detailSelectedSku = null;
            this.dispatchComponentSelected = [];
            this.dispatchComponentSaleZone = {};
            this.detailSelectedSalesZone = [];
            this.existComponent = false;
            this.clearFromChangeSaleZoneOrHarvest();
            $("#dispatchComponentModal").modal("hide");
        },
        getSupplies() {
            this.$store.commit("setLoading", true);
            let data = "Size=10";
            this.Get(this.apiUrl + "v1/supplies?" + data, (res) => {
                this.supplyBottles = res.data.bottles;
                this.supplyCappingInputs = res.data.cappingInputs;
                this.supplyBoxes = res.data.boxes;
                this.supplyCapsules = res.data.capsules;
                this.supplyLabels = res.data.labels;
                this.supplyBackLabels = res.data.backLabels
                this.$store.commit("setLoading", false);
            });
        },
        deleteDispatchComponent(id, sku) {
            this.$swal({
                title: "¿Desea eliminar los Componentes para Despacho?",
                text: sku,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
            }).then((result) => {
                if (result.value) {
                    this.$store.commit("setLoading", true);
                    this.Delete(`${this.apiUrl}v1/requestsample/${this.id}/details/deleteDispatchComponent?dispatchComponentId=${id}`, () => {
                        window.toastr.success(
                            "Los Componentes para Despacho de " + sku + " han sido eliminados correctamente."
                        );
                        this.$store.commit("setLoading", false);
                        this.$emit("saveDispatchComponent");
                    });
                }
            });
        },
        sendEnologySamples() {
            var samplesToOenology = this.detailNew.concat(this.detailFinish);
            this.$store.commit("setLoading", true);
            this.Put(
                `${this.apiUrl}v1/sendSamplesToOenology/`,
                samplesToOenology,
                () => {
                    $("#sendToOenologyModal").modal("hide");
                    this.$store.commit("setLoading", false);
                    window.toastr.success("Muestra(s) enviadas a Enología correctamente");
                    //this.$router.push("/");
                    location.reload();
                }
            );
        },
        sendRevisionSamples() {
            var samplesRevision = this.detailNew
                .concat(this.detailBottle)
                .concat(this.detailFinish);
            this.$store.commit("setLoading", true);
            this.Put(`${this.apiUrl}v1/sendSampleRevision/`, samplesRevision, () => {
                $("#sendRevisionModal").modal("hide");
                this.$store.commit("setLoading", false);
                window.toastr.success("Muestra(s) enviadas a Revisión correctamente");
                //this.$router.push("/");
                location.reload();
            });
        },
        ChangeIconCollapse(item) {
            if ($("#icon" + item).hasClass("fa-angle-down"))
                $("#icon" + item).toggleClass("fa-angle-up");
            else if ($("#icon" + item).hasClass("fa-angle-up"))
                $("#icon" + item).toggleClass("fa-angle-down");
        },
        Valid(id) {
            let list = [];
            list.push(id);
            this.ValidWinery(list);
        },
        ValidAll() {
            let list = [];
            $(".item-to-valid").each(function (i, obj) {
                list.push($(obj).data("detailid"));
            });
            this.ValidWinery(list);
        },
        ValidWinery(list) {
            this.$swal({
                title: "¿Desea validar por componentes la muestra?",
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
            }).then((result) => {
                if (result.value) {
                    this.$store.commit("setLoading", true);
                    this.Put(`${this.apiUrl}v1/details/validwinery/`, list, (res) => {
                        this.$store.commit("setLoading", false);
                        this.listSelectSample = [];
                        window.toastr.success(
                            "Se ha(n) validado la(s) muestra(s) correctamente."
                        );
                        if (res.data.allValid) {
                            this.$router.push(`/solicitudes/visualizar/${this.id}`);
                        } else {
                            this.$emit("validComponent");
                        }
                    });
                }
            });
        },
        showOneSendRevision(item) {
            let itemValues = "<div style='text-align: left'>";
            if (item.requestTypeId === 2)
                itemValues += `Sku: ${item.sku}`
            else if (item.requestTypeId === 3)
                itemValues += `Código: ${item.sku}`
            if (item.brand)
                itemValues += ` <br/>Marca: ${item.brand}`
            if (item.variety)
                itemValues += ` <br/>Vino: ${item.variety}`
            if (item.harvest)
                itemValues += ` ${item.harvest}`
            if (item.valley)
                itemValues += ` ${item.valley}`
            if (item.quality)
                itemValues += ` ${item.quality}`
            if (item.comercialMixCode)
                itemValues += ` <br/>Mezcla Comercial: ${item.comercialMixCode}`
            itemValues += '<br/><br/>Ingrese el Motivo:</div>'
            let itemList = []
            this.$swal({
                title: "¿Desea Enviar a Revisión?:",
                input: "text",
                html: itemValues,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
            }).then((result) => {
                if (result.value) {
                    item.reasonSendToRevision = result.value;
                    itemList.push(item)
                    this.$store.commit("setLoading", true);
                    this.Put(`${this.apiUrl}v1/sendSampleRevision/`, itemList, () => {
                        $("#sendRevisionModal").modal("hide");
                        this.$store.commit("setLoading", false);
                        window.toastr.success("Muestra(s) enviadas a Revisión correctamente");
                        //this.$router.push("/");
                        location.reload();
                    });
                }
            });
        },
        showOneFinishProductSendRevision(detail) {
            this.detailFinishedproductToRevision = detail
            $("#sendOneFinishedProductToRevisionModal").modal("show");
        },
        downloadFile(id) {
            window.open(`${this.apiUrl}v1/documentfile/${id}`);
        },
        sendComponentRevisionSamples(detail) {
            this.$store.commit("setLoading", true);
            this.Put(`${this.apiUrl}v1/sendSampleRevision/`, [detail], () => {
                $("#sendOneFinishedProductToRevisionModal").modal("hide");
                this.$store.commit("setLoading", false);
                window.toastr.success("Muestra(s) enviadas a Revisión correctamente");
                //this.$router.push("/");
                location.reload();
            });
        },
        addObservation(detailId) {
            this.$store.commit("setLoading", true);
            let obs = document.getElementById("observation-input-" + detailId);
            let data = {
                requestCommercialSampleDetailId: detailId,
                observation: obs.value
            };
            this.Post(`${this.apiUrl}v1/RequestDetailObservations`, data, () => {
                this.$store.commit("setLoading", false);
                window.toastr.success("Se ha registrado la Observación correctamente.");
                obs.value = '';
                this.$emit("updateObservations");
            });
        },
        saveOtherSemilaborate() {
            this.detailIdSelected = 0;
            this.detailIdSelectedMCCode = '';
            this.detailIdSelectedPTCode = '';
            $("#otherSemiElaborateModal").modal("hide");
            this.$emit("saveOtherSemilaborate");
            this.$emit("getDetails");
        },
        saveOtherPt() {
            this.detailIdSelected = 0;
            this.detailIdSelectedMCCode = '';
            this.detailIdSelectedPTCode = '';
            $("#otherPtModal").modal("hide");
            this.$emit("saveOtherPt");
            this.$emit("getDetails");
        },
        changeRequireTransfer(detailId) {
            const checkboxElement = document.getElementById('requireTransfer-' + detailId);
            //const checkboxValue = checkboxElement.checked;
            this.$store.commit("setLoading", true);
            let data = {
                requireTransfer: checkboxElement.checked,
                detailId: detailId
            }
            this.Put(`${this.apiUrl}v1/requestsample/${this.id}/details/saveRequireTransfer`, data, () => {
                this.$store.commit("setLoading", false);
                window.toastr.success('Se ha Actualizado el Requiere Trasvasije');
                this.$emit("saveRequireTransfer");
            }
            );
        },
        showStock(type, field, sku, harvest) {
            this.$store.commit("setLoading", true);
            let data = 'Sku=' + sku + '&Type=' + type
            if (harvest)
                data += '&Harvest=' + harvest
            this.Get(this.apiUrl + "v1/MasterItems/GetStock?" + data, (res) => {
                if (field === 'capping')
                    this.stockCapping = res.data
                if (field === 'capsule')
                    this.stockCapsule = res.data
                if (field === 'bottle')
                    this.stockBottle = res.data
                if (field === 'box')
                    this.stockBox = res.data
                if (field === 'label')
                    this.stockLabel = res.data
                if (field === 'backLabel')
                    this.stockBackLabel = res.data
            });
            this.$store.commit("setLoading", false);
        },
        cancelAsignOtherComponents() {
            this.stockCapping = {};
            this.stockCapsule = {};
            this.stockBottle = {};
            this.stockBox = {};
            this.stockLabel = {};
            this.stockBackLabel = {};
            this.capsule = {};
            this.bottle = {};
            this.capping = {};
            this.box = {};
            this.label = {};
            this.backLabel = {};
            this.stock = {}

            this.dispatchComponentBySaleZone = []
            this.dispatchComponentSaleZone = {}
        },
        showStockModal(type, sku, harvest) {
            this.stock = {}
            this.$store.commit("setLoading", true);
            let data = 'Sku=' + sku + '&Type=' + type
            if (harvest)
                data += '&Harvest=' + harvest
            this.Get(this.apiUrl + "v1/MasterItems/GetStock?" + data, (res) => {
                this.stock = res.data;
                this.$swal({
                    title: "Consulta de Stock",
                    html: `<table class="table table-sm table-bordered text-left">
                                <tr>
                                    <th style="width: 160px">Tipo</th>
                                    <td>`+ this.stock.materialDescription + `</td>
                                </tr>
                                <tr>
                                    <th>Sku</th>
                                    <td>`+ this.stock.sku + `</td>
                                </tr>
                                <tr>
                                    <th>Descripción</th>
                                    <td>`+ this.stock.skuDescription + `</td>
                                </tr>
                                <tr>
                                    <th>Cosecha (Año)</th>
                                    <td>`+ this.stock.harvest + `</td>
                                </tr>
                                <tr>
                                    <th>Stock</th>
                                    <td>`+ this.stock.stock + `</td>
                                </tr>
                                <tr>
                                    <th>Actualizado</th>
                                    <td>`+ this.stock.updatedStockAtString + `</td>
                                </tr>
                            </table>`,
                    icon: "info",
                    confirmButtonColor: "#3085d6",
                    width: 800
                });
            });
            this.$store.commit("setLoading", false);
        },
        onSearchBottle(search, loading) {
            if (search.length) {
                loading(true);
                this.searchBottle(loading, search, this)
            }
        },
        onSearchBox(search, loading) {
            if (search.length) {
                loading(true);
                this.searchBox(loading, search, this)
            }
        },
        onSearchCapping(search, loading) {
            if (search.length) {
                loading(true);
                this.searchCapping(loading, search, this)
            }
        },
        onSearchCapsule(search, loading) {
            if (search.length) {
                loading(true);
                this.searchCapsule(loading, search, this)
            }
        },
        searchBottle: _.debounce((loading, search, vm) => {
            let data = "Search=" + search + "&Size=10&Bottle=True";
            vm.Get(vm.apiUrl + "v1/supplies?" + data, (res) => {
                vm.supplyBottles = res.data.bottles;
                loading(false)
            });
        }, 500),
        searchBox: _.debounce((loading, search, vm) => {
            let data = "Search=" + search + "&Size=10&Box=True";
            vm.Get(vm.apiUrl + "v1/supplies?" + data, (res) => {
                vm.supplyBoxes = res.data.boxes;
                loading(false)
            });
        }, 500),
        searchCapping: _.debounce((loading, search, vm) => {
            let data = "Search=" + search + "&Size=10&Capping=True";
            vm.Get(vm.apiUrl + "v1/supplies?" + data, (res) => {
                vm.supplyCappingInputs = res.data.cappingInputs;
                loading(false)
            });
        }, 500),
        searchCapsule: _.debounce((loading, search, vm) => {
            let data = "Search=" + search + "&Size=10&Capsule=True";
            vm.Get(vm.apiUrl + "v1/supplies?" + data, (res) => {
                vm.supplyCapsules = res.data.capsules;
                loading(false)
            });
        }, 500),
        onSearchLabel(search, loading) {
            if (search.length) {
                loading(true);
                this.searchLabel(loading, search, this)
            }
        },
        onSearchBackLabel(search, loading) {
            if (search.length) {
                loading(true);
                this.searchBackLabel(loading, search, this)
            }
        },
        searchLabel: _.debounce((loading, search, vm) => {
            let data = "Search=" + search + "&Size=10&Label=True";
            vm.Get(vm.apiUrl + "v1/supplies?" + data, (res) => {
                vm.supplyLabels = res.data.labels;
                loading(false)
            });
        }, 500),
        searchBackLabel: _.debounce((loading, search, vm) => {
            let data = "Search=" + search + "&Size=10&BackLabel=True";
            vm.Get(vm.apiUrl + "v1/supplies?" + data, (res) => {
                vm.supplyBackLabels = res.data.backLabels;
                loading(false)
            });
        }, 500),
    },
    computed: {
        detailNew: function () {
            return this.details.filter((x) => x.requestTypeId === 1);
        },
        detailNewComponents: function () {
            return this.details.filter(
                (x) => x.requestTypeId === 1 && x.sampleDetailStage === 3
            );
        },
        detailNewNoWineSample: function () {
            return this.details.filter(
                (x) =>
                    x.requestTypeId === 1 &&
                    x.wineSample === false &&
                    x.rejectToWinderyDispatch == null &&
                    x.rejectAt == null
            );
        },
        detailFinish: function () {
            return this.details.filter((x) => x.requestTypeId === 2);
        },
        detailFinishComponents: function () {
            return this.details.filter(
                (x) => x.requestTypeId === 2 && x.sampleDetailStage === 3
            );
        },
        detailBottle: function () {
            return this.details.filter((x) => x.requestTypeId === 3);
        },
        detailBottleComponents: function () {
            return this.details.filter(
                (x) => x.requestTypeId === 3 && x.sampleDetailStage === 3
            );
        },
        detailFinishNoWineSample: function () {
            return this.details.filter(
                (x) =>
                    x.requestTypeId === 2 &&
                    x.wineSample === false &&
                    x.rejectToWinderyDispatch == null &&
                    x.rejectAt == null
            );
        },
        buttonText() {
            if (this.listSelectSample == 0) return "Todo";
            else return "Selección";
        },
        btnDispatchTitle() {
            if (this.listSelectSample == 0)
                return "Se despacharán solo las muestras Validadas";
            else
                return "Se despacharán las muestras seleccionadas que están Validadas";
        },
        btnRejectTitle() {
            if (this.listSelectSample == 0)
                return "Se rechazarán solo las muestras sin validación";
            else
                return "Se rechazarán las muestras seleccionadas que están sin validación";
        },
        courierMessage() {
            let message = "";
            if (!this.courier) message = "Seleccione Courier";
            return message;
        },
        shippingDateMessage() {
            let message = "";
            if (!this.shippingDate) message = "Ingrese fecha de envío";
            return message;
        },
        internalDispatchGuideMessage() {
            let message = "";
            if (!this.internalDispatchGuide) message = "Ingrese N° Guía de Despacho";
            return message;
        },
        isValid() {
            return !this.shippingDateMessage && !this.internalDispatchGuideMessage;
        },
        btnRejectDisabled() {
            if (this.progressDispatch == "Si") {
                for (var i = 0; i < this.listSelectSample.length; i++) {
                    let obj = $("#detailid-" + this.listSelectSample[i]);
                    if (obj.data("validated") == 1) return true;
                }
            }

            return false;
        },
        btnDispatchDisabled() {
            let disabled = true;
            if (this.isValid && this.shippingDate != "" && this.internalDispatchGuide)
                disabled = false;
            else disabled = true;

            if (this.progressDispatch == "Si") {
                for (var i = 0; i < this.listSelectSample.length; i++) {
                    let obj = $("#detailid-" + this.listSelectSample[i]);
                    if (obj.data("validated") == 0) {
                        disabled = true;
                        break;
                    }
                }
            }
            return disabled;
        },
    },
};
</script>
